import React from "react";
import { Modal, Message } from "semantic-ui-react";

import "./Contact.css";
import PhoneImage from "../images/small__icons/call.png";
import MailImage from "../images/small__icons/mail.png";

export const Contact = () => {
  return (
    <div className="contact-us">
      <h1 className="contact-us__title">
        <span>Contact</span> Us (For customization,etc)
      </h1>
      <div className="contact-us__content">
        <div className="contact-us__info">
          <div className="contact-us__commitment">
            <p>
              Our team constantly work on users pros and we welcome your idea
              and we will help you to make your idea into product . If you have
              any plan of messaging services we will provide all kind of custom
              apps in the range web/mobile/data_science
            </p>
          </div>
          <div className="contact-us__address">
            <h3>
              CVRR_Teams/Nitho Inc. <br /> Andhra Pradesh/Thanjavur
              <br />
              India
            </h3>
          </div>
          <div className="contact-us__phone">
            <img alt="" src={PhoneImage} />
            <p>Just email</p>
          </div>
          <div className="contact-us__email">
            <img alt="" src={MailImage} />
            <p>cvrrocket@gmail.com</p>
          </div>
        </div>
        <div className="contact-us__feedback">
          <div>
            <div className="contact-us__form-control">
              <label>Fullname</label>
              <input type="text" />
            </div>
            <div className="contact-us__form-control">
              <label>Email</label>
              <input type="email" />
            </div>
            <div className="contact-us__form-control">
              <label>Feedback</label>
              <textarea rows={10} />
            </div>
            <Modal size={"tiny"} trigger={<button>Send</button>} closeIcon>
              <Modal.Header>
                <Message positive>
                  <p>Your feedback noted</p>
                </Message>
              </Modal.Header>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};
